import React from 'react';
import { func, number, string } from 'prop-types';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';
import Button from 'components/Button';
import GetFreeTrialButton from 'components/GetFreeTrialButton';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './PurchaseArea.scss';

const PurchaseArea = ({
  onButtonClick,
  title,
  description,
  imageUrl,
  buttonText,
  className,
  liveTopicId,
  liveTopicName,
}) => {
  useStyles(styles);

  return (
    <section className={cx(styles.root, className)}>
      <img className={styles.image} src={imageUrl} alt={title} />
      <div className={styles.mask} />
      <div className={styles.wrapper}>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.description}>{description}</p>
        <div className={styles.buttonGroup}>
          <GetFreeTrialButton
            reversed
            type="regular_class"
            id={liveTopicId}
            name={liveTopicName}
            section="syllabus_paywall"
          />
          <Button text={buttonText} onClick={onButtonClick} />
        </div>
      </div>
    </section>
  );
};

PurchaseArea.propTypes = {
  onButtonClick: func.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  imageUrl: string.isRequired,
  buttonText: string.isRequired,
  liveTopicName: string.isRequired,
  liveTopicId: number.isRequired,
  className: string,
};

PurchaseArea.defaultProps = {
  className: '',
};

export default PurchaseArea;
